export default __webpack_public_path__ + "static/media/Map_Mast_Gray.332b5981.svg";